module.exports = __webpack_public_path__ + "img/person1.a078281f.jpg";